import {
  useDeleteCloudEnvironmentsMutation,
  useGetCloudEnvironmentsQuery,
} from "~/services/cloudenvironment";
import { SIMPLCloudEntity } from "../cloudtable/SimplCloudEntity";
import { CloudEnviromentHeader } from "~/models/cloudenvironment/CloudEnviromentHeader";
import { DetailViewCloudEnvironment } from "./DetailsViewCloudEnvironment";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export const SIMPLCloudEnvironment = () => {
  const [isActive, setIsActive] = useState(true);
  const { t } = useTranslation();
  return (
<SIMPLCloudEntity
  title={t("CloudEnviromentManagment")}
  loadingTitle={t("LoadingCloudEnvironments")}
  addLabel={t("AddCloud")}
  tableHeaders={CloudEnviromentHeader}
  fetchHook={useGetCloudEnvironmentsQuery}
  deleteHook={useDeleteCloudEnvironmentsMutation}
  deleteTitle={t("DeleteCloudEnvironment")}
  navigateAddRoute="/cloud-environment/add-cloud"
  navigateEditRoute="/cloud-environment/update"
  detailViewComponent={DetailViewCloudEnvironment}
   showButtonDecommissionInModal={false}
  showButtonDownloadInModal={false}
  showConfigFileInModal={false}
   showButtonDeleteInModal
  showButtonDetailsInModal
  showEditInModal
  isActive={isActive}
  setIsActive={setIsActive}
   activeLabel={t("Active")  }  
  inactiveLabel={t("Inactive")}
  tabs
/>
  );
};